<div [formGroup]="form">
  <p>
    @switch (control.controlType) {
      @case ('textbox') {
        <mat-form-field appearance="outline">
          <mat-label>{{control.label}}</mat-label>
          <input matInput [formControlName]="control.key" [id]="control.key" [type]="control.type">
          @if (!isValid) {
            <mat-error>
              {{control.label}} is required
            </mat-error>
          }
        </mat-form-field>
      }
      @case ('dropdown') {
        <mat-form-field appearance="outline">
          <mat-label>{{control.label}}</mat-label>
          <mat-select [formControlName]="control.key">
            @for (opt of options; track opt) {
              <mat-option [value]="opt.key">{{opt.value}}</mat-option>
            }
          </mat-select>
          @if (!isValid) {
            <mat-error>
              {{control.label}} is required
            </mat-error>
          }
        </mat-form-field>
      }
      @case ('date') {
        <mat-form-field appearance="outline">
          <mat-label>{{control.label}} </mat-label>
          <input formControlName="{{control.key}}" matInput [matDatepicker]="picker1">
          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
          @if (!isValid) {
            <mat-error>
              {{control.label}} is required
            </mat-error>
          }
        </mat-form-field>
      }
    }
  </p>
</div>